import { defineSlotRecipe } from '@chakra-ui/react'

export const progressCircleSlotRecipe = defineSlotRecipe({
  className: 'chakra-progress-circle',
  slots: ['root', 'label', 'track', 'range', 'valueText', 'view', 'circle', 'circleTrack', 'circleRange'],
  base: {
    root: {
      display: 'inline-flex',
      textStyle: 'sm',
      position: 'relative',
    },
    circle: {
      _indeterminate: {
        animation: 'spin 2s linear infinite',
      },
    },
    circleTrack: {
      '--track-color': 'colors.colorPalette.muted',
      stroke: 'var(--track-color)',
    },
    circleRange: {
      stroke: 'colorPalette.solid',
      transitionProperty: 'stroke-dashoffset, stroke-dasharray',
      transitionDuration: '0.6s',
      _indeterminate: {
        animation: 'circular-progress 1.5s linear infinite',
      },
    },
    label: {
      display: 'inline-flex',
    },
    valueText: {
      lineHeight: '1',
      fontWeight: 'medium',
      letterSpacing: 'tight',
      fontVariantNumeric: 'tabular-nums',
    },
  },
  variants: {
    size: {
      xs: {
        circle: {
          '--size': '24px',
          '--thickness': '4px',
        },
        valueText: {
          textStyle: '2xs',
        },
      },
      sm: {
        circle: {
          '--size': '32px',
          '--thickness': '5px',
        },
        valueText: {
          textStyle: '2xs',
        },
      },
      md: {
        circle: {
          '--size': '40px',
          '--thickness': '6px',
        },
        valueText: {
          textStyle: 'xs',
        },
      },
      lg: {
        circle: {
          '--size': '48px',
          '--thickness': '7px',
        },
        valueText: {
          textStyle: 'sm',
        },
      },
      xl: {
        circle: {
          '--size': '64px',
          '--thickness': '8px',
        },
        valueText: {
          textStyle: 'sm',
        },
      },
      '2xl': {
        circle: {
          '--size': '80px',
          '--thickness': '9px',
        },
        valueText: {
          textStyle: 'md',
        },
      },
      '3xl': {
        circle: {
          '--size': '96px',
          '--thickness': '10px',
        },
        valueText: {
          textStyle: 'lg',
        },
      },
      '4xl': {
        circle: {
          '--size': '112px',
          '--thickness': '11px',
        },
        valueText: {
          textStyle: 'xl',
        },
      },
      '5xl': {
        circle: {
          '--size': '128px',
          '--thickness': '12px',
        },
        valueText: {
          textStyle: '2xl',
        },
      },
      '6xl': {
        circle: {
          '--size': '144px',
          '--thickness': '14px',
        },
        valueText: {
          textStyle: '2xl',
        },
      },
      '7xl': {
        circle: {
          '--size': '160px',
          '--thickness': '15px',
        },
        valueText: {
          textStyle: '2xl',
        },
      },
      '8xl': {
        circle: {
          '--size': '176px',
          '--thickness': '15px',
        },
        valueText: {
          textStyle: '2xl',
        },
      },
      '9xl': {
        circle: {
          '--size': '192px',
          '--thickness': '15px',
        },
        valueText: {
          textStyle: '2xl',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
